import { render, staticRenderFns } from "./file-icon.vue?vue&type=template&id=3b3e3e16&"
import script from "./file-icon.vue?vue&type=script&lang=js&"
export * from "./file-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports